
<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="title text-uppercase">
        <span>Gozoom Reputation Services</span>
        <span class="font-weight-light"></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <v-container fluid >
          <router-view />
      </v-container>
    </v-content>

    <v-footer :fixed="fixed" app>
      <div class="gozoom_footer">
      <span class="text-xs-center" >&copy; {{year}} Gozoom Inc. All Rights
      Reserved</span>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
import HelloWorld from './components/HelloWorld';
import SignIn from './views/SignIn.vue';

export default {
  name: 'App',
  components: {
    HelloWorld,
    SignIn,
  },
  computed: {


  },
  methods: {
    ...mapMutations([
      'show_signin_dialog',
    ]),
  },
  data() {
    return {
      year: new Date().getFullYear(),
      fixed: true,
    };
  },
};
</script>

<style>
.gozoom_footer {
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 14px;
    text-transform:uppercase;
    text-align:center;
}

.gozoom_footer {
    width: 100%;
    color: #f2f2f2;
    background: #6e7982;
    padding-top:14px;
}

.gozoom_footer a {
    color: #f2f2f2;
}

.gozoom_footer a:hover {
    color: white;
}

</style>
